export enum CancelReasons {
  SHOPPER_CANCELLED = 'SHOPPER_CANCELLED',
  TOO_MUCH = 'TOO_MUCH',
  MOVING = 'MOVING',
  COMPETITOR = 'COMPETITOR',
  BUDGET = 'BUDGET',
  NOT_ENJOY = 'NOT_ENJOY',
  NO_NEED = 'NO_NEED',
  TRAVELLING = 'TRAVELLING',
  OTHER = 'OTHER',
}
